// extracted by mini-css-extract-plugin
export default {"container":"_32726725","isMobile":"_55db3458"};